import { fetchData } from "./fetchData";

export const uploadExcelAPI = async (route, formData, JobID = null) => {
    const uploadRoute = JobID && route === 'subchains' ? `/${route}/upload/${JobID}` : `/${route}/upload`

    const options = {
        method: 'PUT',
        body: formData
    }

    let response = await fetchData(uploadRoute, options);

    return response;
}
